import { z } from "@hono/zod-openapi";
import { tmsEventKind } from "../base";
import { formSubmissionRefs } from "../subjects/formSubmission/refs";

/**
 * The driver reported an accident.
 */
export const accidentReportV1 = tmsEventKind(
  { category: "exception", kind: "accidentReport", version: 1 },
  {
    refs: formSubmissionRefs,
    facts: {
      /** Free text as the driver typed it. */
      location: z.string().nullable(),
      /** Null when the driver left the question unanswered, which is not the same as answering no. */
      hasInjuries: z.boolean().nullable(),
    },
  },
);

export const AccidentReportV1Schema = accidentReportV1.schema;
export const AccidentReportV1FactsSchema = accidentReportV1.facts;

export type AccidentReportV1 = z.infer<typeof AccidentReportV1Schema>;
export type AccidentReportV1Facts = z.infer<typeof AccidentReportV1FactsSchema>;

/** Every version of `accidentReport`, keyed by version. What `catalog.ts` places under `exception`. */
export const accidentReport = { 1: accidentReportV1 } as const;
